import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../shared/api/client'
import type { AdminDashboardDto } from './types'
import type { DashboardPeriodState } from './useDashboardPeriod'

async function fetchAdminDashboard(p: DashboardPeriodState): Promise<AdminDashboardDto> {
  const params: Record<string, string> = { period: p.key }
  if (p.key === 'custom' && p.from && p.to) {
    params.from = p.from
    params.to = p.to
  }
  const res = await apiClient.get<{ success: true; data: AdminDashboardDto }>('/dashboard/admin', {
    params,
  })
  return res.data.data
}

export function useDashboardData(period: DashboardPeriodState) {
  return useQuery({
    queryKey: ['dashboard', 'admin', period.key, period.from, period.to],
    queryFn: () => fetchAdminDashboard(period),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
